import { httpsCallable } from "firebase/functions";
import { functions } from "..";

export type DesktopUserCreationStatus =
  | "created"
  | "auth/email-already-exists"
  | "error";

export const createDesktopUser = async (
  email: string
): Promise<DesktopUserCreationStatus> => {
  const createUser = httpsCallable<{ email: string }, { status: number }>(
    functions,
    "desktopUserController-createDesktopUser"
  );

  try {
    await createUser({ email });
    return "created";
  } catch (err) {
    const { _, details } = JSON.parse(JSON.stringify(err));
    return details.code;
  }
};

export const deleteDesktopUser = async (email: string): Promise<string> => {
  const deleteUser = httpsCallable<{ email: string }, { status: number }>(
    functions,
    "desktopUserController-deleteDesktopUser"
  );

  try {
    await deleteUser({ email });
    return "deleted";
  } catch (err) {
    const { _, details } = JSON.parse(JSON.stringify(err));
    return details.code;
  }
};
